import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { APP_INITIALIZER, ErrorHandler, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import * as Sentry from '@sentry/angular-ivy';
import { of } from 'rxjs';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ChatInmessageComponent } from './chat-inmessage/chat-inmessage.component';
import { ChatLegacyModule } from './chat-inmessage/chat-legacy/chat-legacy.module';
import { ChatModule } from './chat-inmessage/chat/chat.module';
import { JWTHeaderInterceptor } from './shared/jwt-header.interceptor';
import { SharedModule } from './shared/shared.module';
import { XHRWithCredentialsInterceptor } from './shared/xhr-cred-interceptor';
import { langDe } from './translations/de';
import { langEn } from './translations/en';
import { langEs } from './translations/es';
import { langFr } from './translations/fr';
import { langIt } from './translations/it';

export class CustomLoader implements TranslateLoader {
  getTranslation(lang: string) {
    if (lang === 'fr') {
      return of(langFr);
    } else if (lang === 'it') {
      return of(langIt);
    } else if (lang === 'en') {
      return of(langEn);
    } else if (lang === 'es') {
      return of(langEs);
    } else if (lang === 'de') {
      return of(langDe);
    } else {
      return of(langEn);
    }
  }
}

@NgModule({
  declarations: [AppComponent, ChatInmessageComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useClass: CustomLoader,
      },
    }),
    AppRoutingModule,
    ChatModule,
    ChatLegacyModule,
    SharedModule,
  ],
  /**
   * https://angular.io/api/common/http/HttpInterceptor says:
   * To use the same instance of HttpInterceptors for the entire app, import the HttpClientModule only in your AppModule,
   * and add the interceptors to the root application injector .
   * If you import HttpClientModule multiple times across different modules (for example, in lazy loading modules),
   * each import creates a new copy of the HttpClientModule, which overwrites the interceptors provided in the root module.
   */
  providers: [
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler({
        showDialog: false,
      }),
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    {
      provide: APP_INITIALIZER,
      useFactory: () => () => {},
      deps: [Sentry.TraceService],
      multi: true,
    },
    { provide: HTTP_INTERCEPTORS, useClass: XHRWithCredentialsInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: JWTHeaderInterceptor, multi: true },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
